<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Allocated pickups to delivery agent</strong>
            <div class="card-header-actions">                      
            </div>
          </div>   
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                  <b-col sm="12" >
                  <b-form-group label="Delivery Agent" :label-cols="3">  
                    <!-- <b-form-select v-model="customer.deliveryagentmasterid" name="deliveryagentname" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.deliveryagentname') }">
                      <option :value="selected">--Select Delivery Agent--</option>
                      <option :value="customer.deliveryagentmasterid" v-for="customer in data1">{{ customer.deliveryagentfirstname | capitalize }}{{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber }}</option>
                    </b-form-select> -->
                    <v-select  v-model="customer.deliveryagentmasterid" :options="data1" placeholder="Select Delivery Agent" @input="selectdeliveryagent(customer.deliveryagentmasterid)"  name="deliveryagentname" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.deliveryagentname') }">
                    </v-select>
                    <span v-show="errors.has('form-1.deliveryagentname')" class="help is-danger" style="color:red">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>
                </b-col>
                <b-col md="6" >
                 <b-button type="submit" size="md" class="mr-4" variant="primary">Show</b-button>
                </b-col>
              </b-row>               
            </form>
          </div>
          <b-col sm="12" >
           <b-table show-empty stacked="md" :busy="isBusy" :items="DAPendingStatus"  :fields="fields"   :outlined="outlined"  >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>             
            </b-table>
          </b-col>
          <div>
            <input type="hidden" name="isactiveId" id="isactiveId" value="">
            <input type="hidden" name="deliveryagentmasterId" id="deliveryagentmasterId" value="">
            <table class="table b-table border b-table-stacked-md"  :outlined="outlined">
             
              <thead role="rowgroup">
                <tr v-if="DAAvaliablePickUPListData !== 0" role="row">
                
                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="1" aria-label="Click to sort Ascending"  class="">Pickup Location Name </th>
                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="2" aria-label="Click to sort Ascending"  class="">Pickup Location Address </th>

                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="3" aria-label="Click to sort Ascending"  class="">POC Mobile Number </th>

                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="4" aria-label="Click to sort Ascending"  class="">Total To Pick </th>

                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="5" aria-label="Click to sort Ascending"  class="">Allocate</th>

                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="6" aria-label="Click to sort Ascending"  class="">Vendor Code</th>

                  <th tabindex="0" role="columnheader" scope="col" aria-colindex="7" aria-label="Click to sort Ascending"  class="">POC Name</th>
               </tr>
              </thead>
              <tbody role="rowgroup" v-if="DAAvaliablePickUPListData !== 0">
                <tr v-for="value in data" role="row">

                  <td role="cell" aria-colindex="1" data-label="pickup location name " class=""><div>{{ value.pickuplocationname }}</div></td>

                   <td role="cell" aria-colindex="2" data-label="pickup location address " class=""><div>{{ value.pickuplocationaddress }}</div></td>
                   <td role="cell" aria-colindex="3" data-label="pickup mobile number address " class=""><div>{{ value.pocmobilenumber }}</div></td>

                  <td role="cell" aria-colindex="4" data-label="total consignments" class="" v-bind:id="totalassgntxt + value.pickuplocationmasterid" >
                   <div> <a @click="toggleInfoModal(value)">
                    {{ value.totalconsignments }}
                    </a></div> 
                  </td>

                  <td role="cell" aria-colindex="5" data-label="allocate Call" class="">
                   <div> <form @submit.prevent="allocateCall(value)">
                      <div class="columns" >
                        <div class="column">
                          <div class="field">
                            <p class="control">
                              <input class="input" type="number" v-bind:value='value.totalconsignments' @keyup="onBlur(value.pickuplocationmasterid)" v-bind:id="'totalAllocationsAllowedCls_' + value.pickuplocationmasterid" style="width:70px">
                              <span style="display:none;" v-bind:id="'msg' + value.pickuplocationmasterid"></span>
                            </p>
                          </div>
                        </div>
                        <div class="column">
                          <button href="" class="editbtn" data-toggle="tooltip" title="Allocate"  style="background: #b0c4de !important;color: #000 !important;"><i class="fa fa-check-square" style="#444"></i></button>
                        </div>
                      </div>
                    </form></div>
                  </td>
                  <td role="cell" aria-colindex="6" data-label="clientvendorcode" class=""><div>{{ value.clientvendorcode }}</div></td>
                  <td role="cell" aria-colindex="7" data-label="pocname" class=""><div>{{ value.pocname }}</div></td>
                </tr>
               
                <tr v-if="data.length === 0 && DAAvaliablePickUPListData !== 0" role="row" class="b-table-empty-row"><td colspan="9" role="cell"><div role="alert" aria-live="polite"><div class="text-center my-2">There are no records to show</div></div></td></tr>
              </tbody>
            </table>
          </div>
         
          <b-modal title="Allocated"  v-model="toggleInfo" size="md" @ok="toggleInfo = false" class="modal-info" ok-variant="info">  
            <form v-on:submit.prevent="validate('form-3')" data-vv-scope="form-3">
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Allocated</p>
                  <button class="delete" type="button" @click="toggleInfoModal(value)"></button>
                </header>
                <section class="modal-card-body">
                  <div class="table-responsive">
                    <input type="hidden" name="isactiveId" id="isactiveId" value="">
                    <input type="hidden" name="deliveryagentmasterId" id="deliveryagentmasterId" value="">
                    <table class="table table-striped table-bordered allocatetblecls">
                      <thead>
                        <tr v-if="filterdata.length>0">
                          <th>Shipment Location ID</th>
                          <th>Pickup Location Name</th>
                          <th>Total To Pick</th>
                          <th>Allocate</th>
                          <th>Vendor Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, index) in filterdata" v-bind:id="'allocateCls_' + index">
                          <td>{{ value.shippincode }}</td>
                          <td>{{ value.pickuplocationname }}</td>
                          <td><a @click="toggleInfoModal2(value)">{{ value.totalconsignments }}</a></td>
                          <td style="width:220px;">
                            <form @submit.prevent="allocateCallfilter(value,index)">
                              <div class="columns" style="width:50px">
                                <div class="column">
                                  <div class="field">
                                    <p class="control ">
                                      <input class="input" type="hidden" name='currindex' v-bind:id='index'>
                                      <input class="input allocateinputcls" type="number" v-bind:value='value.totalconsignments' @keyup="onBlurCall(index)" v-bind:id="'totalassgntxtfilterinput' + index" style="width:70px">
                                      <span style="display:none;" v-bind:id="'msgfilter' + index"></span>
                                    </p>
                                  </div>
                                </div>
                                <div class="column">
                                  <button href="" class="editbtn" data-toggle="tooltip" title="Allocate" v-bind:id="'addAllocateCls' + index"><i class="fa fa-check-square" style="#444"></i></button>
                                </div>
                              </div>
                            </form>
                          </td>
                          <td>{{ value.clientvendorcode }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </form>
          </b-modal>
          
          <b-modal title="Shipment List"  v-model="toggleInfo2" size="md" @ok="toggleInfo2 = false" class="modal-info" ok-variant="info">  
            <form v-on:submit.prevent="validate('form-2')" data-vv-scope="form-2">
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Shipment List</p>
                  <button class="button" type="button" @click="AllocationAllShipmentToSR()" style="margin-right:10px;background:#344953;color:#ffffff">Allocate Shipments</button>
                  <button class="delete" type="button" @click="toggleInfoModal2()"></button>
                </header>
                <section class="modal-card-body">
                  <div class="table-responsive">

                    <table class="table table-striped table-bordered allocatetblecls">
                      <thead>
                        <tr v-if="filterdata2.length>0">
                          <th><input class="checkallchk" type="checkbox"  @change="checkAll(false)" v-bind:false-value="true"/></th>
                          <th>Shipment ID</th>
                          <th>Pickup Location Name</th>
                          <th>customer Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, index) in filterdata2" v-bind:id="'allocateClsTest_' + index">
                          <td><input class="shipmentscheckbox" type="checkbox"  v-bind:value="value.consignmentmasterid" name="shippingid"
                                v-bind:false-value="true" /></td>
                          <td>{{ value.shippingid }}</td>
                          <td>{{ value.pickuplocationname }}</td>
                          <td>{{ value.customeraddress }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </form>
          </b-modal>

          <b-modal title="Delivery Allocation Location"  v-model="toggleDeAllocateInfo" size="md" @ok="toggleDeAllocateInfo = false" class="modal-info" ok-variant="info">
              <template slot="modal-header" slot-scope="{ close }">
              <h5>Cancel Pickup</h5>
               <a  @click="toggleDeAllocateModal(value)"> <i class="fa fa-times" ></i></a>
              </template>
              <template slot="default" slot-scope="{ hide }">
                <form v-on:submit.prevent="validate('form-3')" data-vv-scope="form-3">     <div class="table-responsive">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr v-if="filterdata1.length>0">
                            <th>Pickup Location Name</th>
                            <th>Total Allocations</th>
                            <th>Cancel Reasons</th>
                            <th>DeAllocate</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(value, index) in filterdata1" v-bind:id="'cancelPickupId_'+ index">
                            <td>{{ value.pickuplocationname }}</td>
                            <td>{{ value.totalallocations }}</td>
                            <td>
                              <b-form-group>
                                <b-input-group class="mb-3">  
                                <b-form-select  v-model="value.deliverystatuscode" name="deliverystatuscode">
                                  <option :value="selected">--Select--</option>
                                  <option  value="6">Pickup not ready with vendor</option>
                                  </b-form-select>                         
                                </b-input-group>
                              </b-form-group>
                             
                            </td>
                            <td>
                              <button href="" class="editbtn deallocateinputcls" data-toggle="tooltip" v-bind:id="'deAllocateCls' + index" title="DeAllocate" @click="deAllocateApiCall(value,index)"><i class="fa fa-check-square" ></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>               
                </form>
              </template>
               <template slot="modal-footer" slot-scope="{ cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="sm" variant="danger"  style="display:none" >
                  Cancel
                </b-button>
                 <!-- Button with custom close trigger value -->
             </template>  
          </b-modal>

        </b-card>
      </b-col>
     </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      selected:'',
      name: 'allocation',
      data: [],
      DAPendingStatus: [],
      data1: [],
      pincodeallocatedata: [],
      allocatedata: [],
      toggleInfo: false,
      toggleInfo2: false,
      toggleDeAllocateInfo: false,
      allocated: [],
      customer: {
        deliveryagentmasterid:'',
      },
      totalassgntxt: 'totalassgntxt',
      modalvalue: 'modalvalue',
      filterdata: [],
      filterdata1: [],
      filterdata2: [],
      shipment:"",
      alloctionId:"",
      isSearchDAPendingStatus: 0,
      DAAvaliablePickUPListData: 0,
      isBusy: false,
      isBusy2: false,
      outlined:true,
       fields: [
          { key: 'daname', label: 'Delivery Agent Name ', sortable: true, sortDirection: 'desc' },
          { key: 'forwardpickup', label: 'Forward pickup', sortable: true},
          { key: 'reversepickup', label: 'Reverse pickup', sortable: true},
          { key: 'deliverypending', label: 'Delivery pending', sortable: true},          
          { key: 'totaldelivered', label: 'Delivered', sortable: true },    
          { key: 'totalrto', label: 'RTO' },
          { key: 'handoverpending', label: 'handoverpending' },
          { key: 'codcollectable', label: 'codcollectable' },
          { key: 'codcollected', label: 'codcollected'}
        ],
    }
  },
  created: function() {
    this.displaydata()
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.showData()
        }
      })
    },
    allocateCallfilter: function(value, index) {
      var inputnumber = document.getElementById('totalassgntxtfilterinput' + index).value
      if (isNaN(inputnumber) || inputnumber === '') {
        document.getElementById('msgfilter' + index).style.color = 'red'
        document.getElementById('msgfilter' + index).innerHTML = ' You need to enter a number'
        document.getElementById('msgfilter' + index).style.display = 'block'
        return false
      }
      inputnumber = Number(inputnumber)
      if (inputnumber < 0) {
        document.getElementById('msgfilter' + index).style.color = 'red'
        document.getElementById('msgfilter' + index).innerHTML = 'You need to enter a positive number'
        document.getElementById('msgfilter' + index).style.display = 'block'
        return false
      }
      if (inputnumber > value.totalconsignments) {
        document.getElementById('msgfilter' + index).style.color = 'red'
        document.getElementById('msgfilter' + index).innerHTML = 'You need to enter  number less than or equal to totalconsignments number'
        document.getElementById('msgfilter' + index).style.display = 'block'
        return false
      }
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      document.getElementById('msgfilter' + index).innerHTML = ''
      document.getElementById('msgfilter' + index).style.display = 'none'
      const customerGetobj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
        lastmodifiedby: `${userInfo.sysemailid}`,
        totalallocations: inputnumber,
        mobilenumber: `${value.pocmobilenumber}`,
        pickuplocationmasterid: `${value.pickuplocationmasterid}`,
        shippincode: `${value.shippincode}`,
      }
      document.getElementById('allocateCls_' + index).style.backgroundColor = '#D3D3D3'
      // console.log('----------rakesh------------');
      // console.log(customerGetobj);
            // console.log('----------rakesh------------');

      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/ConsignmentMasterMarkBookingDoneMultiple`, customerGetobj)
        .then((result) => {
          this.allocatedata = result.body
          if (this.allocatedata.returnmsg === 'Successful') {
             this.DAPendingStatus = [];
              this.data=[];
            alert('Location id allocated successfully');
            // this.$fire({
            //       text:"Location id allocated successfully",
            //       type: "success",
            //       timer: 30000
            //     }); 

          } else {
            if (this.allocatedata.returnmsg === 'UnSuccessful' || this.allocatedata.returnmsg === 'Error' || this.allocatedata.returnmsg === 'error') {
               alert(this.customer.totalallocationenew + ' Location id not allocated');  
                // this.$fire({
                //   text:this.customer.totalallocationenew + "Location id allocated",
                //   type: "error",
                //   timer: 30000
                // });        
            } else {
              alert(this.allocatedata.returnmsg);
              // this.$fire({
              //     text:this.allocatedata.returnmsg,
              //     type: "error",
              //     timer: 30000
              //   });        

              
            }
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    allocateCall: function(value) {
      // alert(value);
      // console.log("Value",value);
      var inputnumber = document.getElementById('totalAllocationsAllowedCls_' + value.pickuplocationmasterid).value
      if (isNaN(inputnumber) || inputnumber === '') {
        document.getElementById('msg' + value.pickuplocationmasterid).style.color = 'red'
        document.getElementById('msg' + value.pickuplocationmasterid).innerHTML = ' You need to enter a number'
        document.getElementById('msg' + value.pickuplocationmasterid).style.display = 'block'
        return false
      }
      inputnumber = Number(inputnumber)
      if (inputnumber < 0) {
        document.getElementById('msg' + value.pickuplocationmasterid).style.color = 'red'
        document.getElementById('msg' + value.pickuplocationmasterid).innerHTML = 'You need to enter a positive number'
        document.getElementById('msg' + value.pickuplocationmasterid).style.display = 'block'
        return false
      }
      if (inputnumber > value.totalconsignments) {
        document.getElementById('msg' + value.pickuplocationmasterid).style.color = 'red'
        document.getElementById('msg' + value.pickuplocationmasterid).innerHTML = 'You need to enter  number less than or equal to totalconsignments number'
        document.getElementById('msg' + value.pickuplocationmasterid).style.display = 'block'
        return false
      }
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      document.getElementById('msg' + value.pickuplocationmasterid).innerHTML = ''
      document.getElementById('msg' + value.pickuplocationmasterid).style.display = 'none'
      var result = confirm('Are you sure you want to allocate confirm?')
      // var result =this.$confirm("Are you sure?")
      if (result) {
        const customerGetobj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
          lastmodifiedby: `${userInfo.sysemailid}`,
          totalallocations: inputnumber,
          mobilenumber: `${value.pocmobilenumber}`,
          pickuplocationmasterid: `${value.pickuplocationmasterid}`
        }
         // console.log('----------rakesh------------');
      // console.log(customerGetobj);
            // console.log('----------rakesh------------');
        document.getElementById('totalAllocationsAllowedCls_' + value.pickuplocationmasterid).value = ''
        this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/ConsignmentMasterMarkBookingDoneMultiple`, customerGetobj)
          .then((result) => {
            this.allocatedata = result.body
            if (this.allocatedata.returnmsg === 'Successful') {
             this.DAPendingStatus = [];
             this.data=[];
              // alert('Location Id allocated successfully');
               this.$fire({
                  text:"Location Id allocated successfully",
                  type: "success",
                  timer: 30000
                }); 
             
            } else {
              if (this.allocatedata.returnmsg === 'UnSuccessful' || this.allocatedata.returnmsg === 'Error' || this.allocatedata.returnmsg === 'error') {
             
                //  alert(this.customer.totalallocationenew + 'Location Id not allocated');
                 this.$fire({
                  text:this.customer.totalallocationenew +"Location Id allocated",
                  type: "success",
                  timer: 30000
                }); 
              } else {
                // alert(this.allocatedata.returnmsg)
                 this.$fire({
                  text:this.allocatedata.returnmsg,
                  type: "warning",
                  timer: 30000
                }); 
              }
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
      }
    },
    onBlur: function(pickuplocationmasterid) {
      document.getElementById('msg' + pickuplocationmasterid).style.color = ''
      document.getElementById('msg' + pickuplocationmasterid).innerHTML = ''
      document.getElementById('msg' + pickuplocationmasterid).style.display = 'none'
    },
    onBlurCall: function(pickuplocationmasterid) {
      document.getElementById('msgfilter' + pickuplocationmasterid).style.color = ''
      document.getElementById('msgfilter' + pickuplocationmasterid).innerHTML = ''
      document.getElementById('msgfilter' + pickuplocationmasterid).style.display = 'none'
    },
    deAllocateApiCall: function(value, index) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      if (typeof value.deliverystatuscode != 'undefined') {
        const deAllocateObj = {
          pickuplocationmasterid: `${value.pickuplocationmasterid}`,
          deliverystatuscode: `${value.deliverystatuscode}`,
          lastmodifiedby: `${userInfo.sysemailid}`,
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`
        }
        document.getElementById('cancelPickupId_' + index).style.backgroundColor = "#D3D3D3"
        document.getElementById('deAllocateCls' + index).disabled = true
        this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/DAMarkPickupCancelVendor`, deAllocateObj)
          .then((result) => {
            this.deallocatedata = result.body
            if (this.deallocatedata.returnmsg === 'successful') {
              this.showData();
              // alert(' Cancel Pickup successfully ')
                this.$fire({
                  text:" Cancel Pickup Successfully",
                  type: "success",
                  timer: 30000
                }); 

            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
      } else {
        // alert("Please select cancel reason")
         this.$fire({
                  text:" Please select cancel reason",
                  type: "warning",
                  timer: 30000
                }); 
      }
    },
    checkAll:function(flag){
    var checkboxes = document.getElementsByClassName('shipmentscheckbox');
    var ele = document.getElementsByClassName('checkallchk');

    if(flag){
      ele[0].checked=false;
      for (var i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].type == 'checkbox') {
              checkboxes[i].checked = false;
          }
      }
    }else{
      if (ele[0].checked) {
          for (var i = 0; i < checkboxes.length; i++) {
              if (checkboxes[i].type == 'checkbox') {
                  checkboxes[i].checked = true;
              }
          }
      } else {
          for (var i = 0; i < checkboxes.length; i++) {
              if (checkboxes[i].type == 'checkbox') {
                  checkboxes[i].checked = false;
              }
          }
      }
    }



    },
    toggleInfoModal: function(s) {
      document.getElementById("toggleInfo2").classList.remove("is-active");
      if (typeof s != 'undefined') {
        this.alloctionId=s;
        const filterobj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
          filterby: 'shippincode',
          pickuplocationmasterid: s.pickuplocationmasterid
        }
        this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DAAvaliablePickUPList`, filterobj)
          .then((result) => {
            this.filterdata = result.body
            if(this.filterdata.length > 0) {
            } else {
              // alert('Requested user has not allocated any location')
              this.$fire({
                  text:" Requested user has not allocated any location",
                  type: "warning",
                  timer: 30000
                }); 
              document.getElementById("toggleInfo").classList.remove("is-active");
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
      }
      var y = document.getElementsByClassName('allocateinputcls')

      for (var i = 0; i < y.length; i++) {
        var msgele = y[i].nextElementSibling
        msgele.style.color = ''
        msgele.innerHTML = ''
        msgele.style.display = 'none'
        document.getElementById('allocateCls_' + i).style.backgroundColor = ''
      }
      // console.log(s)
      if(s===undefined){
        document.getElementById("toggleInfo").classList.remove("is-active");
      }else{
        document.getElementById("toggleInfo").classList.add("is-active");
      }

      this.showData()
    },
    AllocationAllShipmentToSR: function(){

        var y = document.getElementsByClassName('shipmentscheckbox')
        var tempArr=[];
        var agentMastermobile= this.filterdata2[0].deliveryagentmobilenumber;
        if(y.length>0){
          for (var i = 0; i < y.length; i++) {
              if (y[i].checked == true){
                tempArr.push(y[i].value)
              }
          }
        }
        var filterobj={
          consignmentmasterid:tempArr,
          deliveryagentmobilenumber: agentMastermobile,
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`
        }
        this.$http.post(`${CONSTANTS.API_URL}/daallocateshipment`, filterobj)
          .then((result) => {
            if(result.body != "successful"){
              // alert(result.body.returnmsg)
              this.$fire({
                  text:result.body.returnmsg,
                  type: "success",
                  timer: 30000
                }); 
            }else {
              this.toggleInfoModal(this.alloctionId);
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
    },
    toggleInfoModal2: function(s) {




        if (typeof s != 'undefined') {

          const filterobj = {
            deliveryagentmasterid: this.customer.deliveryagentmasterid.key,
            shippincode: `${s.shippincode}`,
            pickuplocationmasterid: s.pickuplocationmasterid
          }
          this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DAAvaliablePickUPListByLocation`, filterobj)
            .then((result) => {

              this.filterdata2 = result.body
              if (this.filterdata2.length > 0) {} else {
                // alert('Requested user has not allocated shipment not Available  ')
                this.$fire({
                  text:" Requested user has not allocated shipment not Available",
                  type: "warning",
                  timer: 30000
                }); 
              }
            })
            .catch((ex) => {

              console.log('error', ex)
            })

        }
        if(s===undefined){

          this.toggleInfoModal(this.alloctionId);
        }else{
          document.getElementById("toggleInfo2").classList.add("is-active");
          this.checkAll(true);
        }


    },
    toggleDeAllocateModal: function(s) {
      if (typeof s != 'undefined') {
        const filterobj1 = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
          filterby: ''
        }
        this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/GetConsignmentPickUpPendingListDA`, filterobj1)
          .then((result) => {
            this.filterdata1 = result.body
          })
          .catch((ex) => {
            console.log('error', ex)
          })
      }
      var y = document.getElementsByClassName('deallocateinputcls')
      for (var i = 0; i < y.length; i++) {
        document.getElementById('deAllocateCls' + i).disabled = false
      }
      this.toggleDeAllocateInfo = !this.toggleDeAllocateInfo
    },
    GetSortOrder: function(prop) {
      return function(a, b) {
        if (a[prop] > b[prop]) {
          return 1
        } else if (a[prop] < b[prop]) {
          return -1
        }
        return 0
      }
    },
    modal: function() {
      // console.log('modal')
    },
    
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      //console.log("hello"+userInfo.sysusermasterid);
     if(userInfo.sysusermasterid==25 || userInfo.sysusermasterid==39)
     {
     
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        usertype:'4',

      }
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     }
   
     else
     {
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'

      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    }
 
      
    },
    showData: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isBusy = true;
      this.isBusy2 = true;
      const obj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/GellAllDAPendingStatus`, obj)
        .then((result) => {
          this.DAPendingStatus = result.body.returnvalue
          this.isSearchDAPendingStatus = 1
          this.isBusy = !this.isBusy;
          if (this.DAPendingStatus.length > 0) {} else {
            //alert('No records found  ')

          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      const customerGetobj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DAAvaliablePickUPList`, customerGetobj)
        .then((result) => {
          this.data = result.body;
          this.isBusy2 = !this.isBusy2;
          this.DAAvaliablePickUPListData = 1
          // if (this.data.length > 0) {
            
          // } 
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    allocate: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var inputnumber = this.customer.totalallocationenew
      inputnumber = Number(inputnumber)
      if (inputnumber < 0) {
        document.getElementById('errormsg').style.color = 'red'
        document.getElementById('errormsg').innerHTML = 'You need to enter a positive number'
        document.getElementById('errormsg').style.display = 'block'
        return false
      } else if (inputnumber > this.customer.totalconsignments) {
        document.getElementById('errormsg').style.color = 'red'
        document.getElementById('errormsg').innerHTML = 'You need to enter  number less than or equal to totalconsignments number'
        document.getElementById('errormsg').style.display = 'block'
        return false
      } else {
        document.getElementById('errormsg').innerHTML = ''
        document.getElementById('errormsg').style.display = 'none'
        const customerGetobj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid.key}`,
          lastmodifiedby: `${userInfo.sysemailid}`,
          totalallocations: `${this.customer.totalallocationenew}`,
          mobilenumber: `${this.customer.pocmobilenumber}`,
          pickuplocationmasterid: `${this.customer.pickuplocationmasterid}`
        }
        var totalassgntxt = document.getElementById('totalassgntxt' + this.customer.pickuplocationmasterid).innerText
        var total = (totalassgntxt - this.customer.totalallocationenew)
        this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/ConsignmentMasterMarkBookingDoneMultiple`, customerGetobj)
          .then((result) => {
            this.allocatedata = result.body
            if (this.allocatedata.returnmsg === 'Successful') {
              document.getElementById('totalassgntxt' + this.customer.pickuplocationmasterid).innerText = total
              // alert(this.allocatedata.returnmsg + ' Location Id allocated successfully  ')
               this.$fire({
                  text:this.allocatedata.returnmsg +"  Location Id allocated successfully ",
                  type: "success",
                  timer: 30000
                }); 
              this.customer.totalallocationenew = ''
            } else {
              if (this.allocatedata.returnmsg === 'UnSuccessful' || this.allocatedata.returnmsg === 'Error' || this.allocatedata.returnmsg === 'error') {
              //  alert(this.customer.totalallocationenew + ' Location Id not allocated   ')
               this.$fire({
                  text:this.customer.totalallocationenew +"  Location Id not allocated  ",
                  type: "warning",
                  timer: 30000
                }); 
              } else {
              //  alert(this.allocatedata.returnmsg)
                this.$fire({
                  text:this.allocatedata.returnmsg,
                  type: "error",
                  timer: 30000
                }); 
              }
            }
          })
          .catch((ex) => {
            console.log('error', ex)
          })
      }
      this.toggleInfo = !this.toggleInfo
    },

    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.customer.deliveryagentmasterid = '';
          this.DAAvaliablePickUPListData = 0;
          this.isSearchDAPendingStatus = 0;
          this.DAPendingStatus = [];
          this.displaydata();
        }
         console.log("value_vehicle : ",value_vehicle);
    },
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

